export default "__VITE_ASSET__C9l5f14K__"